/* eslint-disable no-undef */
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Root from './routes/Root';
import { ReactNotifications } from 'react-notifications-component';
import { ExportJobsWidget, LoadingSrc, ReactModal, ScrollToTop } from './components';
import Modal from 'react-modal';
import SocketUtils from './core/utils/socket';
import { useStore } from './core/utils/hook';
import { observer } from 'mobx-react';
import GoogleAnalytics from './components/GoogleAnalytics/GoogleAnalytics';
import { SYSTEM_PATH } from './core/configs/constants';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './App.scss';


// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const App = observer(() => {

    const {
        authStore: { userInfo, token, clearAuthentication, showLoadingSrc },
        modalStore: { openAlert },
        messageStore: { pushNewMessage },
        apiStore: { loading },
        settingTopPageStore: { setAttrObservable }
    } = useStore();

    const isProduction = process.env.REACT_APP_GA_TRACKING_ID;

    useEffect(() => {
        if (window.location.pathname === SYSTEM_PATH.HOME_PREVIEW) {
            setAttrObservable('isPreview', true);
        } else {
            setAttrObservable('isPreview', false);
        }
    }, [window.location.pathname]);

    useEffect(() => {
        window.history.scrollRestoration = 'manual';
    }, []);

    useEffect(() => {
        if (userInfo && token) {
            SocketUtils.getInstance().init({ token, userId: userInfo.id, onLogout, onNewMessage });
        }
    }, [userInfo, token]);

    const LOGOUT_MESSAGES = {
        another_device: '複数デバイス、ブラウザでの同時視聴はできませんので、こちらの画面は自動ログアウトしました。',
        confirm_email: 'メールアドレスの確認が完了したため、自動的にログアウトしました。'
    };

    const onLogout = (reason) => {
        const message = LOGOUT_MESSAGES[reason] ?? LOGOUT_MESSAGES.another_device;
        openAlert(message, () => {
            clearAuthentication();
        });
    }

    const onNewMessage = (payload) => {
        if (payload?.messageInfo && payload?.emails && payload.emails.includes(userInfo?.email)) {
            pushNewMessage(payload.messageInfo);
        }
    }

    return (
        <>
            <Suspense fallback=''>
                {isProduction && <GoogleAnalytics />}
                <ReactNotifications isMobile={true} breakpoint={500}/>
                <BrowserRouter>
                    <ScrollToTop>
                        <Routes>
                            <Route>
                                {/* public route - with out authenticate */}
                                {/* private route - with authenticate and base layout*/}
                                <Route path='/*' element={<Root />} />
                            </Route>
                        </Routes>
                    </ScrollToTop>
                </BrowserRouter>
                {/* <Loading/> */}
                <ReactModal />
                <ExportJobsWidget />
                {
                    (showLoadingSrc || loading) && <LoadingSrc />
                }
            </Suspense>
        </>
    );
})

export default App;
